import { render } from "./FAQMicro.vue?vue&type=template&id=4c87be8e"
import script from "./FAQMicro.vue?vue&type=script&lang=js"
export * from "./FAQMicro.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/agradata/agradata/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__